import React from "react";
import { connect } from "react-redux";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";
import { EmailAttachedFile, EmailAttachedFileList } from "@mapmycustomers/ui";
import { Divider } from "@mapmycustomers/ui";

import { downloadEmailAttachedFile } from "@app/store/email/actions";
import getRecipientDisplayName from "@app/util/email/getRecipientDisplayName";

import styles from "./EmailPreviewView.module.scss";
import SentEmailBody from "./SentEmailBody";

const messages = defineMessages({
  recipientLabel: {
    id: "email.preview.recipientLabel",
    defaultMessage: "To: {recipient}",
    description: "Email preview - recipient label",
  },
  subjectLabel: {
    id: "email.preview.subjectLabel",
    defaultMessage: "Subject: {subject}",
    description: "Email preview - subject label",
  },
});

interface EmailPreviewViewProps {
  attachedFiles: EmailAttachedFile[];
  body: string;
  className?: string;
  recipient: EntitiesSupportedByEmailFeature;
  subject: string;
}

const EmailPreviewView = ({
  attachedFiles,
  body,
  className,
  onFileDownload,
  recipient,
  subject,
}: EmailPreviewViewProps & typeof mapDispatchToProps) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.label}>
        {intl.formatMessage(messages.recipientLabel, {
          recipient: getRecipientDisplayName(recipient),
        })}
      </div>
      <div className={styles.label}>
        {intl.formatMessage(messages.subjectLabel, {
          subject,
        })}
      </div>
      <Divider className={styles.divider} />
      {attachedFiles.length > 0 && (
        <>
          <EmailAttachedFileList
            files={attachedFiles}
            onFileDownload={(attachedFile) => onFileDownload({ attachedFile })}
            onFilePreview={(attachedFile) => onFileDownload({ attachedFile, preview: true })}
            readOnly
          />
          <Divider className={styles.divider} />
        </>
      )}
      <SentEmailBody body={body} className={styles.body} />
    </div>
  );
};

const mapDispatchToProps = {
  onFileDownload: downloadEmailAttachedFile,
};

export default connect(null, mapDispatchToProps)(EmailPreviewView);
